import styled from "styled-components";
import { Theme } from "theme";

export const TrackName = styled.span<{
  played: boolean;
}>`
  font-size: 15pt;

  @media (max-width: 700px) {
    font-size: 13pt;
  }

  @media (max-width: 500px) {
    font-size: 12pt;
  }

  ${({ played }) => played && "font-weight: bold;"}
  ${({ played }) => !played && `color: ${Theme.unplayedTrackTextColor};`}
`;

export const BannedTrackName = styled.span`
  font-size: 15pt;
  font-weight: 500;
  color: ${Theme.bannedTrackTextColor};
  vertical-align: middle;

  @media (max-width: 700px) {
    font-size: 13pt;
  }

  @media (max-width: 500px) {
    font-size: 12pt;
  }
`;

export const PickName = styled.span`
  font-size: 12pt;
  color: gray;

  @media (max-width: 700px) {
    font-size: 11pt;
  }

  @media (max-width: 500px) {
    font-size: 10pt;
  }
`;

export const BanName = styled.span`
  font-size: 12pt;
  color: maroon;

  @media (max-width: 700px) {
    font-size: 11pt;
  }

  @media (max-width: 500px) {
    font-size: 10pt;
  }
`;

export const DnfIcon = styled.img`
  width: 20px;
  height: 16px;
  padding: 0 1px;
  filter: brightness(50%);
  @media (max-width: 700px) {
    width: 17px;
    height: 14px;
  }
  @media (max-width: 600px) {
    width: 16px;
    height: 14px;
  }
`;
